import { h, Component } from 'preact';
import { route } from 'preact-router';

// Static Bootstrap 5 preview card for a feed post's attached map — NOT a real
// Leaflet map. Instantiating a Leaflet map per card in an infinite-scroll
// feed is a real memory/jank cost on phones, so the feed only ever shows a
// pin icon, the marker count and the first marker's label, and opens the
// full post (which renders the real Leaflet map) on click.
class MapFeedPreview extends Component {
    openArticle = (e) => {
        e.preventDefault();
        const { article, onOpenArticle } = this.props;
        if (!article) return;
        if (onOpenArticle) {
            onOpenArticle(article);
            return;
        }
        route(`/article/${encodeURIComponent(article.title || '').toLocaleLowerCase()}/${article.uuidv4}`);
    }

    render() {
        const { article } = this.props;
        const markers = article?.mapMarkers || [];
        // Latitude/longitude of 0 is a real value (e.g. off the coast of
        // Africa) — never filter markers on truthiness of the coordinates,
        // only on whether they are actually numbers.
        const validMarkers = markers.filter(m => m
            && Number.isFinite(m.latitude)
            && Number.isFinite(m.longitude));
        if (validMarkers.length === 0) return null;

        const firstMarker = validMarkers[0];

        return (
            <div
                class='my-3 p-3 rounded-3 d-flex align-items-center bg-body-secondary border-start border-4 border-primary'
                style='cursor: pointer;'
                onClick={this.openArticle}
                data-testid='map-feed-preview'
            >
                <div class='flex-shrink-0 me-3'>
                    <i class='fa-solid fa-map-location-dot fa-2x text-primary' />
                </div>
                <div class='flex-fill'>
                    <div class='fw-bold text-body' data-testid='map-feed-preview-count'>
                        {validMarkers.length} {validMarkers.length === 1 ? 'markør' : 'markører'}
                    </div>
                    {firstMarker.label && (
                        <div class='text-body-secondary small' data-testid='map-feed-preview-label'>
                            {firstMarker.label}
                        </div>
                    )}
                </div>
                <div class='flex-shrink-0 ms-2'>
                    <i class='fa-solid fa-chevron-right text-body-secondary' />
                </div>
            </div>
        );
    }
}

export default MapFeedPreview;
